import ChangePassword from './ChangePassword';

const Profile = () => {
  return (
    <div>
      <ChangePassword />
    </div>
  );
};
export default Profile;
